import { Card } from "@/components/ui/card";

const impactData = [
  {
    number: "+6,000",
    label: "Professionals Trained",
    variant: "light" as const
  },
  {
    number: "500+",
    label: "Companies Collaborated", 
    variant: "dark" as const
  },
  {
    number: "+150k",
    label: "Community Members",
    variant: "dark" as const
  }
];

export const ImpactNumbers = () => {
  return (
    <section className="py-16 sm:py-24 bg-background" data-nav-theme="dark">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Liquid Glass Container */}
        <div className="rounded-3xl p-6 sm:p-8" style={{
          backdropFilter: 'blur(60px) saturate(200%)',
          WebkitBackdropFilter: 'blur(60px) saturate(200%)',
          background: 'linear-gradient(145deg, hsla(0, 0%, 70%, 0.12), hsla(0, 0%, 60%, 0.08), hsla(0, 0%, 50%, 0.06))',
          border: '1px solid hsla(0, 0%, 70%, 0.2)',
          boxShadow: '0 12px 48px hsla(0, 0%, 0%, 0.06), inset 0 1px 1px hsla(0, 0%, 100%, 0.15), inset 0 -1px 0 hsla(0, 0%, 0%, 0.03)',
        }}>
          <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">
            {/* Header */}
            <div className="lg:w-64 flex-shrink-0">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-normal text-foreground font-general-sans leading-tight">
                Our Impact<br />
                in Numbers
              </h2>
            </div>

            {/* Impact Cards */}
            <div className="flex-1 flex flex-col sm:flex-row gap-4 sm:gap-6">
              {impactData.map((item, index) => (
                <Card 
                  key={index}
                  className={`
                    group relative p-6 lg:p-8 rounded-2xl transition-all duration-500 origin-bottom liquid-glass
                    ${item.variant === "light" 
                      ? "text-foreground hover:rotate-[-8deg] hover:scale-105 hover:shadow-xl" 
                      : "bg-foreground/90 text-background border-foreground/20 hover:rotate-[-8deg] hover:scale-105 hover:shadow-xl"
                    }
                  `}
                  style={{
                    transformStyle: 'preserve-3d',
                  }}
                >
                  <div className="space-y-2">
                    <div className={`
                      text-4xl md:text-5xl font-semibold font-general-sans
                      ${item.variant === "light" ? "text-foreground" : "text-background"}
                    `}>
                      {item.number}
                    </div>
                    <div className={`
                      text-sm md:text-base font-normal font-general-sans
                      ${item.variant === "light" ? "text-muted-foreground" : "text-background/90"}
                    `}>
                      {item.label}
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};